import { removeByPath } from "../../../utility";
import { ArsContextState, IArsActionRemoveItem } from "../interface";

/**
 * Removes an item at a JSON-pointer path.
 *
 * @param state - Current ARS context state
 * @param action - Remove-item action
 * @returns Updated state with the item removed and changed set for updateARS
 */
export const arsc_removeArsItem = <T>(
  state: ArsContextState<T>,
  action: IArsActionRemoveItem,
): ArsContextState<T> =>
  removeByPath({ ...state, changed: true }, action.dataPath, action.newLength);
